<template>
    <div class="card">
        <TabView @tab-change="handleTabChange">
            <TabPanel header="จัดกลุ่มตามช่วงเวลา">
                <statistic-disaster-range-time></statistic-disaster-range-time>
            </TabPanel>
            <TabPanel header="เปรียบเทียบสถิติเดือนเดียวกันในแต่ละปี">
                <statistic-disaster-year></statistic-disaster-year>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import statisticDisasterRangeTime from './StatisticDisasterRangeTime';
import statisticDisasterYear from './StatisticDisasterYear';

export default {
    components: {
        statisticDisasterRangeTime,
        statisticDisasterYear
    },
    data() {
      return{
          
      }    
    },

    watch:{

    },

    mounted(){
    },

    methods: {
        handleTabChange(newTab){
            console.log(newTab.tab.$vnode.componentOptions.propsData.header)
        }
    }
}
</script>